import React from 'react';
import Image from 'next/image';

import styles from './ProductCard.module.scss';

export interface ProductCardProps {
  productImage: string;
  displayName: string;
  productUrl: string;
  displayPrice: string;
  salePrice: string;
  trackClick?: () => void;
}

const ProductCardAlt = ({
  productImage,
  displayName,
  productUrl,
  displayPrice,
  salePrice,
  trackClick,
}: ProductCardProps) => {
  const strippedPrice = parseInt(displayPrice?.replace?.(/\D/g, '') || '0');

  const truncateDisplayName = (name: string) => {
    if (name?.length > 55) {
      return `${name.substring(0, 55)}...`;
    }
    return name;
  };

  const displaySale = !!salePrice;

  const Price = () => {
    if (strippedPrice === 0) return null;

    if (displaySale) {
      return (
        <p className={styles.price}>
          <span className={styles.salePrice}>{salePrice}</span>{' '}
          <span className={styles.originalPrice}>{displayPrice}</span>
        </p>
      );
    }

    return <p className={styles.price}>{displayPrice}</p>;
  };
  return (
    <article>
      <a
        className={styles.productCard}
        href={productUrl}
        onClick={() => trackClick?.()}
      >
        <div className={styles.image}>
          <Image
            src={productImage}
            alt={displayName}
            width={200}
            height={200}
            quality="55"
            sizes="(min-width: 1280px) 292px, (min-width: 820px) 21vw,(min-width: 720px) 35.51vw, 63vw"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
        <div className={styles.contentContainer}>
          <p className={styles.name}>{truncateDisplayName(displayName)}</p>
          <Price />
        </div>
      </a>
    </article>
  );
};

export default ProductCardAlt;
